import { render, staticRenderFns } from "./WarehouseSidebarDetails.vue?vue&type=template&id=5e1f79bb&scoped=true&"
import script from "./WarehouseSidebarDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseSidebarDetails.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseSidebarDetails.vue?vue&type=style&index=0&id=5e1f79bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f79bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1f79bb')) {
      api.createRecord('5e1f79bb', component.options)
    } else {
      api.reload('5e1f79bb', component.options)
    }
    module.hot.accept("./WarehouseSidebarDetails.vue?vue&type=template&id=5e1f79bb&scoped=true&", function () {
      api.rerender('5e1f79bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Warehouses/components/WarehouseSidebarDetails.vue"
export default component.exports